import React from "react";

import { Small } from "@fronterahealth/frontera-ui-components";

import { Loader } from "@components/ClinicalNewReportDialog/Loader";

export const RefreshingIndicator: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-4 h-full">
      <Loader className="w-6 h-6 text-text-secondary" />
      <Small>This can take a couple of minutes. </Small>
      <Small>Feel free to navigate away, we’ll continue updating your data.</Small>
    </div>
  );
};
